<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="dashboard"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <div class="bg-comment rounded">
        <v-row class="mx-1">rate
          <v-col cols="12" class="content_category rounded-lg">
              <v-rating
                v-model="commentDetail.rate"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$ratingFull"
                large
                hover
              ></v-rating>
          </v-col>
          <v-col cols="5" class="content_category rounded-lg">
            <v-text-field
                background-color="#EDF2F7"
                filled
                :text="commentDetail.name"
                v-model="commentDetail.name"
                label="Họ tên"
                placeholder="Họ tên"
            ></v-text-field>
          </v-col>
          <v-col cols="5" class="content_category rounded-lg">
            <v-text-field
                background-color="#EDF2F7"
                filled
                :text="commentDetail.email"
                v-model="commentDetail.email"
                label="Email"
                placeholder="Email"
            ></v-text-field>
          </v-col>
          <v-col cols="5" class="content_category rounded-lg">
                <v-text-field
                    background-color="#EDF2F7"
                    filled
                    v-model="dateComment"
                    label="Ngày tạo"
                    append-icon="mdi-calendar-range"
                    readonly
                ></v-text-field>

          </v-col>
          <v-col cols="5" class="content_category rounded-lg">
            <v-select
                filled
                class="width-input"
                background-color="#EDF2F7"
                v-model="commentDetail.type"
                :items="active"
                item-text="name"
                item-value="id"
                label="Người dùng"
            ></v-select>
          </v-col>
          <v-col cols="10">
            <v-textarea
                v-model="commentDetail.comment"
                background-color="#EDF2F7"
                filled
                label="Nội dung"
            >
            </v-textarea>
          </v-col>
          <v-col cols="3">
          <v-select
              filled
              class="width-input"
              background-color="#EDF2F7"
              v-model="commentDetail.status"
              :items="active_status"
              item-text="name"
              item-value="id"
              label="Hiển thị"
          ></v-select>
          </v-col>
          <v-col cols="6">
            <v-file-input
                label="Ảnh"
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change="fileSelected"
            ></v-file-input>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col cols="2" v-for="(img,index) in list_imgs" :key="img.id">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center">
                    <v-img
                        height="150"
                        width="150"
                        :src="img.url"

                    ></v-img>
                  </v-col>
                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn
                        @click="clearImg(index)"
                        x-small
                        outlined
                        fab
                        color="red"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="10" class="text-center mt-10">
            <v-btn color="primary" width="180" @click="update_tag">
              Lưu
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
import {
  UPLOAD_COMMENT_IMAGE,
  GET_DETAIL_COMMENT,
  UPDATE_COMMENT,
} from "@/store/modules/comments";
import {mapGetters} from "vuex";

export default {
  components: {},
  data() {
    return {
      page: "Chi tiết",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Bình luận đánh giá",
          disabled: true,
        },
        {
          text: "Danh sách bình luận trả lời",
          disabled: true,
        },
      ],
      dateComment: "",
      dateCommentFomat: "",
      menuComment: false,
      src: "",
      image: {},
      hasImage: false,
      selectedFile: null,
      active: [
        {id: 1, name: 'KHÁCH HÀNG'},
        {id: 2, name: 'QUẢN TRỊ VIÊN'},
      ],
      active_status: [
        {id:1, name:'CHƯA DUYỆT'},
        {id:2, name:'ĐÃ DUYỆT'},
        {id:3, name:'KHÔNG DUYỆT'},
      ],
      list_imgs: [],
    };
  },
  mounted() {
    this.dateComment = this.commentDetail.created_at
  },
  watch: {
    commentDetail(val) {
      const _this = this;
      if (val && val.list_media) {
        val.list_media.forEach((el, index) => {
          _this.list_imgs.push({
            id: el.id,
            url: el.path,
          })
          if (el.isMain) {
            _this.isMain = index;
          }
        });
      }
      if (val && val.created_at) {
        this.dateComment = val.created_at
      }
    },
    dateComment() {
      this.dateComment = this.formatDate(this.commentDetail.created_at)
    }
  },
  async created() {
    await this.$store.dispatch(`${GET_DETAIL_COMMENT}`, this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      comments: "comments",
      commentDetail: "commentDetail",
    }),
  },
  methods: {
    formatDate(date) {
      if (!date) return null;
      let newDate = new Date(date);
      const [year, month, day] = [
        newDate.getFullYear(),
        newDate.getMonth() + 1,
        newDate.getDate(),
      ];
      let day_format = day > 9 ? day : `0${day}`;
      let month_format = month > 9 ? month : `0${month}`;

      return `${day_format}/${month_format}/${year}`;
    },
    fileSelected(event) {
      const _this = this;
      if (!event) {
        this.commentDetail.list_media = []
      } else {
        let formData = new FormData();
        // event.forEach(element => {
        formData.append("upload", event);
        formData.append("type", "comments");
        _this.$store.dispatch(`${UPLOAD_COMMENT_IMAGE}`, formData).then((data) => {
          data.data.data.forEach(el => {
            let data_media = {
              id: el.media_id,
              url: el.url,
            }
            _this.list_imgs.push({
              id: el.media_id,
              url: el.url,
            })
            _this.commentDetail.list_media.push(data_media);
          })
        })
        // })
      }
    },
    clearImg(index) {
      this.list_imgs.splice(index, 1)
      this.commentDetail.list_media.splice(index, 1)
      this.$forceUpdate()
    },
    update_tag() {
      var moment = require("moment-timezone");
      const today = new Date();
      var timeGet = moment(today);
      var newYork = moment.tz(timeGet, "America/Scoresbysund");
      this.dateCommentFomat = newYork.format('YYYY-MM-DD HH:mm:ss')
      let params = {
        id: this.$route.params.id,
        comment: this.commentDetail.comment,
        product_id: this.commentDetail.product_id,
        rate: this.commentDetail.rate,
        status: this.commentDetail.status,
        name: this.commentDetail.name,
        parent_comment_id:this.commentDetail.parent_comment_id,
        phone: this.commentDetail.phone,
        email: this.commentDetail.email,
        type: this.commentDetail.type,
        list_media: JSON.stringify(this.commentDetail.list_media),
        created_at: this.dateCommentFomat,
      }
      this.$store.dispatch(`${UPDATE_COMMENT}`, params).then((data) => {
        if (data) {
          this.$toasted.success('Cập nhật thành công!', {
            position: "top-center",
            theme: "toasted-primary",
            duration: 2000
          });
          this.$router.push(`/comment/detail_comment/${this.commentDetail.parent_comment_id}`);
        }
      });
    },
  },
};
</script>
<style lang="scss">
.bg-comment {
  width: 80%;
  background: #ffffff !important;
}
</style>